import { useEffect, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerAuthHandlers } from '@shared/api';
import { ROUTES } from '@shared/config/routes';
import { useSessionStore } from '@entities/session';
import { refreshTokens } from '@features/auth';

export function AuthBootstrap({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const hydrate = useSessionStore((s) => s.hydrate);

  useEffect(() => {
    hydrate();
    registerAuthHandlers({
      onRefresh: refreshTokens,
      onUnauthorized: () => {
        useSessionStore.getState().clear();
        navigate(ROUTES.login, { replace: true });
      },
    });
  }, [hydrate, navigate]);

  return <>{children}</>;
}
